/**
 * Browser hardening: disable right-click and common dev-tools shortcuts.
 *
 * Pure side-effect module — `import` it once at app entry. Has no
 * runtime API. This is defensive-in-depth only; sensitive operations
 * are still enforced server-side.
 */

if (typeof window !== 'undefined') {
  document.addEventListener('contextmenu', (e) => e.preventDefault());

  document.addEventListener('keydown', (e) => {
    // F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
    if (
      e.key === 'F12' ||
      (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i')) ||
      (e.ctrlKey && e.shiftKey && (e.key === 'J' || e.key === 'j')) ||
      (e.ctrlKey && (e.key === 'U' || e.key === 'u'))
    ) {
      e.preventDefault();
    }
  });
}
